import React, { Component } from 'react'
import Display from '../../../../v2SPRINTA/atoms/Display'
import { FluidContainer, Row, Col, Container } from '../../../../v2SPRINTA/atoms/Grid'
import CoverImage from '../../../../SPRINTA/atoms/CoverImage'

class Institucional extends Component {

    render() {
        return (
            <FluidContainer>
                <Row>
                    <CoverImage
                        image={require('./top_banner.jpg')}
                        shadow='300'
                        style={{ backgroundColor: '#333', color: '#fff' }}>
                        <Container>
                            
                            <Row alignItems='center' justifyContent="center"  style={{ paddingTop: '100px', marginBottom: '100px' }}>
                                <Col size='12 12 11' text='center'>
                                    <Display heading size={1}><b>Cadastre</b> sua academia</Display>
                                    <br />

                                    <Display size={2}>
                                        Facilite o acesso a sua academia, aumente sua receita e divulgue ela gratuitamente para milhares de pessoas
                                    </Display>
                                    <br />
                                </Col>
                            </Row>
                        </Container>

                        
                    </CoverImage>
                </Row>
            </FluidContainer>
        )
    }

}

export default Institucional


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/Institucional/index.js